module.exports = __webpack_public_path__ + "static/media/swift.03195697.png";